<!-- @format -->

<div class="detail">
  @if (listType() === "program" && info()?.preview) {
    <app-program-preview-toolbar />
  }
  <div class="detail__body">
    @if (info()) {
      <div class="info detail__section detail__info">
        <div class="info__cover" [class.info__cover--program]="listType() === 'program'">
          @if (listType() === "program") {
            <div class="info__cover-frame">
              <img
                class="info__program-cover-image"
                [src]="programCover"
                [appImageFraming]="programCoverFraming"
                alt="Обложка программы"
              />
            </div>
          } @else {
            <img class="info__cover" [src]="info().coverImageAddress || defaultCover" alt="cover" />
          }

          <div
            class="info__avatar"
            (click)="redirectDetailInfo()"
            [class.info__avatar--project]="listType() === 'project'"
            [class.info__avatar--program]="listType() === 'program'"
            [style.width.px]="avatarSize"
          >
            @if (chatStateService.userOnlineStatusCache | async; as cache) {
              <app-avatar
                [imageFraming]="
                  listType() === 'program' ? (info().imageFraming?.logo ?? null) : null
                "
                [url]="listType() === 'profile' ? info().avatar : info().imageAddress"
                [hasBorder]="true"
                [borderColor]="listType() === 'project' ? 'white' : 'dark-grey'"
                [progress]="info().progress"
                [onlineBadgeSize]="15"
                [onlineBadgeBorder]="0"
                [onlineBadgeOffset]="8"
                [size]="avatarSize"
                [isOnline]="cache[info().id] !== undefined ? cache[info().id] : info().isOnline"
              ></app-avatar>
              @if (appWidth >= 1000 && listType() === "profile") {
                <h1
                  class="info__title text-body-12"
                  [style.width]="
                    listType() === 'project' || listType() === 'profile' ? '300px' : '100%'
                  "
                  [class.info__title--project]="
                    listType() === 'project' || listType() === 'profile'
                  "
                >
                  {{
                    listType() === "project"
                      ? info().name
                      : listType() === "profile"
                        ? info().firstName + " " + info().lastName
                        : ""
                  }}
                </h1>
              }
            }
          </div>
        </div>

        <div class="info__body" [class.info__body--project]="listType() === 'project'">
          @if (appWidth < 1000) {
            <app-page-header
              class="info__page-header"
              [title]="
                listType() === 'profile' ? info().firstName + ' ' + info().lastName : info().name
              "
            />
          }
          <div
            class="info__actions"
            [class.info__actions--program]="listType() === 'program'"
            [class.info__actions--manager]="listType() === 'program' && isUserManager()"
          >
            <ng-container
              *ngTemplateOutlet="
                listType() === 'program'
                  ? programTpl
                  : listType() === 'profile'
                    ? profileTpl
                    : projectTpl
              "
            ></ng-container>
          </div>

          @if (appWidth >= 1000 && listType() === "program" && !publicationsOnly()) {
            <h1 class="info__program-heading text-body-18">{{ info().name }}</h1>
          }

          @if (appWidth >= 1000 && listType() === "project") {
            <h1 class="info__project-title text-body-12">{{ info().name }}</h1>
          }

          <ng-template #programTpl>
            @if (userType() !== undefined || publicationsOnly()) {
              @if (
                (isProjectsPage() ||
                  isProjectsRatingPage() ||
                  isAnalyticsPage() ||
                  isPublishedSolutionsPage() ||
                  isMembersPage()) &&
                appWidth < 1000
              ) {
                <a [routerLink]="AppRoutes.program.detail(info().id)">
                  <app-button
                    appearance="outline"
                    size="small"
                    class="info__contacts"
                    customTypographyClass="text-body-12"
                  >
                    <span>назад</span>
                  </app-button>
                </a>

                @if (isUserMember() && info().links?.length) {
                  <app-button
                    appearance="outline"
                    size="small"
                    [disabled]="!info().links?.length"
                    class="info__contacts"
                    customTypographyClass="text-body-12"
                    (click)="isContactsModalOpen.set(true)"
                  >
                    <i appIcon icon="phone" appSquare="12"></i>
                    @if (appWidth < 1000) {
                      <span>Контакты</span>
                    }
                  </app-button>
                }

                <app-modal
                  [open]="isContactsModalOpen()"
                  (openChange)="isContactsModalOpen.set(!isContactsModalOpen())"
                  bodyClass="modal__body--no-flex"
                >
                  <app-program-links
                    title="контакты"
                    icon="phone"
                    [links]="contactLinks()"
                  ></app-program-links>
                </app-modal>
              } @else {
                <div class="info__primary-action">
                  @if (
                    !isUserMember() &&
                    !isUserManager() &&
                    !isUserExpert() &&
                    !info().pendingExpertInvitationId
                  ) {
                    @if (getProgramRegistrationLink(info()); as registrationLink) {
                      <a
                        (click)="checkPrograRegistrationEnded($event, info())"
                        [href]="registrationLink"
                      >
                        <app-button
                          appearance="outline"
                          size="medium"
                          customTypographyClass="text-body-12"
                        >
                          зарегистрироваться
                        </app-button>
                      </a>
                    } @else {
                      <span
                        class="info__unavailable"
                        tabindex="0"
                        role="button"
                        aria-disabled="true"
                        aria-describedby="registration-unavailable"
                      >
                        <app-button
                          appearance="outline"
                          size="medium"
                          [disabled]="true"
                          customTypographyClass="text-body-12"
                          >зарегистрироваться</app-button
                        >
                        <span id="registration-unavailable" class="info__unavailable-tooltip">
                          Организатор еще не открыл регистрацию.
                        </span>
                      </span>
                    }
                  }
                  @if (
                    isUserMember() &&
                    !isUserManager() &&
                    !isUserExpert() &&
                    !info().pendingExpertInvitationId
                  ) {
                    <app-button
                      [size]="appWidth >= 1000 ? 'medium' : 'big'"
                      [disabled]="
                        info().preview ||
                        info().solutionActionAvailable === false ||
                        (info().solutionStorageMode !== 'solution' &&
                          (!!submissionProjectDateExpired || isProjectAssigned())) ||
                        applicationPending()
                      "
                      [appearance]="isProjectAssigned() ? 'outline' : 'inline'"
                      (click)="
                        info().solutionStorageMode === 'solution' || !isProjectAssigned()
                          ? addNewProject(info().id)
                          : null
                      "
                      customTypographyClass="text-body-12 bar__add-project"
                    >
                      <span>{{ applicationLabel() }}</span>
                      <i appIcon icon="plus" appSquare="10"></i>
                    </app-button>
                  }
                  @if (info().pendingExpertInvitationId && !isUserExpert()) {
                    <a
                      routerLink="/office/evaluation"
                      [queryParams]="{ invitation: info().pendingExpertInvitationId }"
                      ><app-button
                        appearance="outline"
                        [size]="appWidth >= 1000 ? 'medium' : 'big'"
                        customTypographyClass="text-body-12"
                        >Принять приглашение</app-button
                      ></a
                    >
                  }
                  @if (isUserExpert()) {
                    <a
                      [routerLink]="AppRoutes.program.rating(info().id, info().solutionStorageMode)"
                    >
                      <app-button
                        [appearance]="
                          isProjectsRatingPage() || appWidth < 1000 ? 'inline' : 'outline'
                        "
                        [size]="appWidth >= 1000 ? 'medium' : 'big'"
                        customTypographyClass="text-body-12"
                      >
                        {{
                          info().solutionStorageMode === "solution"
                            ? "оценка решений"
                            : "оценка проектов"
                        }}
                      </app-button>
                    </a>
                  }
                </div>

                @if (isUserManager()) {
                  <a [routerLink]="AppRoutes.program.management(info().id)">
                    <app-button
                      [appearance]="isAnalyticsPage() ? 'inline' : 'outline'"
                      [size]="appWidth >= 1000 ? 'medium' : 'big'"
                      customTypographyClass="text-body-12"
                    >
                      управление программой
                    </app-button>
                  </a>
                } @else {
                  <a [href]="info().presentationAddress" download="" target="_blank">
                    <app-button
                      appearance="outline"
                      [size]="appWidth >= 1000 ? 'medium' : 'small'"
                      customTypographyClass="text-body-12"
                    >
                      <span>{{
                        info().name.includes("Технолидеры Будущего")
                          ? "Каталог лучших стартапов 2022/23"
                          : "положение"
                      }}</span>
                      <i
                        appIcon
                        class="info__presentation-icon"
                        [icon]="appWidth >= 1000 ? 'arrow-down' : 'file'"
                        [appSquare]="appWidth >= 1000 ? '8' : '12'"
                      ></i>
                    </app-button>
                  </a>
                }

                @if (appWidth >= 1000) {
                  <div class="info__divider"></div>
                }
                @if (appWidth < 1000) {
                  @if (isUserMember() && info().links?.length) {
                    <app-button
                      appearance="outline"
                      size="small"
                      [disabled]="!info().links?.length"
                      class="info__contacts"
                      customTypographyClass="text-body-12"
                      (click)="isContactsModalOpen.set(true)"
                    >
                      <i appIcon icon="phone" appSquare="12"></i>
                      @if (appWidth < 1000) {
                        <span>Контакты</span>
                      }
                    </app-button>
                  }
                }
                @if (!isUserManager() && info().solutionStorageMode === "solution") {
                  <a
                    [routerLink]="AppRoutes.program.publishedSolutions(info().id)"
                    routerLinkActive
                    #publishedLink="routerLinkActive"
                    [attr.aria-current]="publishedLink.isActive ? 'page' : null"
                  >
                    <app-button
                      [appearance]="publishedLink.isActive ? 'inline' : 'outline'"
                      [size]="appWidth >= 1000 ? 'medium' : 'small'"
                      customTypographyClass="text-body-12"
                      >решения</app-button
                    >
                  </a>
                } @else if (
                  !isUserManager() && (isUserExpert() || info().publishedProjectsAvailable)
                ) {
                  <a
                    [routerLink]="
                      info().publishedProjectsAvailable
                        ? AppRoutes.program.projects(info().id)
                        : null
                    "
                  >
                    <app-button
                      [appearance]="isProjectsPage() ? 'inline' : 'outline'"
                      size="medium"
                      [disabled]="!info().publishedProjectsAvailable"
                      customTypographyClass="text-body-12"
                    >
                      проекты-участники
                    </app-button>
                  </a>
                }
                @if (
                  !isUserManager() &&
                  !isUserExpert() &&
                  appWidth >= 1000 &&
                  info().solutionStorageMode !== "solution" &&
                  !info().publishedProjectsAvailable
                ) {
                  <a class="info__more">
                    <app-button
                      appearance="outline"
                      [disabled]="true"
                      size="medium"
                      customTypographyClass="text-body-12"
                    >
                      узнать подробнее
                    </app-button>
                  </a>
                }
                @if (!isUserManager() && isUserExpert() && appWidth >= 1000) {
                  <a [routerLink]="AppRoutes.program.members(info().id)" class="info__members">
                    <app-button
                      [appearance]="isMembersPage() ? 'inline' : 'outline'"
                      size="medium"
                      [disabled]="isUserExpert() && !isUserManager()"
                      customTypographyClass="text-body-12"
                    >
                      участники
                    </app-button>
                  </a>
                }
                @if (appWidth < 1000 && !isUserManager()) {
                  <app-button
                    appearance="outline"
                    size="big"
                    [disabled]="!info().materials?.length"
                    class="info__materials"
                    [class.info__materials--full]="isUserManager() || isUserExpert()"
                    customTypographyClass="text-body-12"
                    (click)="isMaterialsModalOpen.set(true)"
                  >
                    материалы
                  </app-button>
                }
                @if (!isUserManager() && !isUserExpert()) {
                  <app-button
                    (click)="
                      info().courses?.length
                        ? router.navigateByUrl(AppRoutes.courses.detail(info().courses[0].id))
                        : null
                    "
                    appearance="outline"
                    [disabled]="!info().courses?.length"
                    [size]="appWidth >= 1000 ? 'medium' : 'big'"
                    customTypographyClass="text-body-12"
                  >
                    {{ appWidth >= 1000 ? "перейти в курс" : "курс" }}
                  </app-button>
                }

                @defer (when isAssignProjectToProgramModalOpen()) {
                  <app-modal
                    [open]="isAssignProjectToProgramModalOpen()"
                    (openChange)="
                      isAssignProjectToProgramModalOpen.set(!isAssignProjectToProgramModalOpen())
                    "
                  >
                    <div class="cancel" style="width: 100%">
                      <div class="cancel__top">
                        <i
                          (click)="isAssignProjectToProgramModalOpen.set(false)"
                          appIcon
                          appSquare="10"
                          icon="cross"
                          class="cancel__cross"
                        ></i>
                        <p class="cancel__title text-body-14">
                          {{
                            info().solutionStorageMode === "solution"
                              ? "не удалось открыть решение"
                              : "произошла ошибка при редактировании!"
                          }}
                        </p>
                      </div>
                      <p class="text-body-12 cancel__text">
                        {{ assignProjectToProgramModalMessage() }}
                      </p>
                    </div>
                  </app-modal>
                }

                @defer (when isProgramEndedModalOpen()) {
                  <app-modal
                    [open]="isProgramEndedModalOpen()"
                    (openChange)="isProgramEndedModalOpen.set(!isProgramEndedModalOpen())"
                  >
                    <div class="cancel" style="padding: 24px">
                      <div class="cancel__top">
                        <p class="cancel__title text-body-14">
                          к сожалению, программа уже завершена!
                        </p>
                      </div>

                      <i appIcon icon="sad-smile" appSquare="50" style="margin-top: 36px"></i>
                    </div>
                  </app-modal>
                }

                @defer (when isProgramSubmissionProjectsEndedModalOpen()) {
                  <app-modal
                    [open]="isProgramSubmissionProjectsEndedModalOpen()"
                    (openChange)="
                      isProgramSubmissionProjectsEndedModalOpen.set(
                        !isProgramSubmissionProjectsEndedModalOpen()
                      )
                    "
                  >
                    <div class="cancel" style="padding: 24px">
                      <div class="cancel__top">
                        <p class="cancel__title text-body-14">
                          к сожалению, подача проекта уже завершена!
                        </p>
                      </div>

                      <i appIcon icon="sad-smile" appSquare="50" style="margin-top: 36px"></i>
                    </div>
                  </app-modal>
                }

                @defer (when isContactsModalOpen()) {
                  <app-modal
                    [open]="isContactsModalOpen()"
                    (openChange)="isContactsModalOpen.set(!isContactsModalOpen())"
                    bodyClass="modal__body--no-flex"
                  >
                    <app-program-links
                      title="контакты"
                      icon="phone"
                      [links]="contactLinks()"
                    ></app-program-links>
                  </app-modal>
                }

                @defer (when isMaterialsModalOpen()) {
                  <app-modal
                    [open]="isMaterialsModalOpen()"
                    (openChange)="isMaterialsModalOpen.set(!isMaterialsModalOpen())"
                    bodyClass="modal__body--no-flex"
                  >
                    <app-program-links
                      title="материалы"
                      icon="book"
                      [links]="materialLinks()"
                    ></app-program-links>
                  </app-modal>
                }
              }
            }
          </ng-template>

          <ng-template #projectTpl>
            @if (isInProject()) {
              <span
                class="info__unavailable"
                tabindex="0"
                role="group"
                aria-label="Рабочая зона"
                aria-describedby="workspace-coming-soon"
              >
                <app-button
                  [disabled]="true"
                  appearance="outline"
                  size="medium"
                  customTypographyClass="text-body-12"
                >
                  рабочая зона
                </app-button>
                <span class="info__unavailable-tooltip" role="tooltip" id="workspace-coming-soon"
                  >Появится позже</span
                >
              </span>
            } @else {
              <a class="info__presentation" [href]="info().presentationAddress" target="_blank">
                <app-button appearance="outline" size="medium" customTypographyClass="text-body-12">
                  <span>презентация</span>
                  <i appIcon icon="arrow-down" appSquare="6"></i>
                </app-button>
              </a>
            }
            @if (!isInProject()) {
              <app-button
                [disabled]="true"
                appearance="outline"
                size="medium"
                customTypographyClass="text-body-12"
              >
                написать
              </app-button>
            } @else {
              <span
                class="info__unavailable"
                tabindex="0"
                role="group"
                aria-label="Чат проекта"
                aria-describedby="chat-coming-soon"
              >
                <app-button
                  [disabled]="true"
                  appearance="outline"
                  size="medium"
                  customTypographyClass="text-body-12"
                >
                  чат проекта
                </app-button>
                <span class="info__unavailable-tooltip" role="tooltip" id="chat-coming-soon"
                  >Появится позже</span
                >
              </span>
            }

            <div class="info__divider"></div>

            <app-button
              [routerLink]="AppRoutes.projects.team(info().id)"
              tabindex="-1"
              [appearance]="isTeamPage() ? 'inline' : 'outline'"
              size="medium"
              customTypographyClass="text-body-12"
            >
              команда
            </app-button>

            @if (isInProject()) {
              @if (profile()) {
                @if (profile()?.id === info().leader) {
                  <a
                    class="info__edit"
                    [routerLink]="
                      isEditDisable()
                        ? AppRoutes.projects.detail(info().id)
                        : AppRoutes.projects.edit(info().id)
                    "
                    [queryParams]="isEditDisable() ? {} : { editingStep: 'main' }"
                  >
                    <app-button
                      appearance="outline"
                      size="medium"
                      customTypographyClass="text-body-12"
                      (click)="onUnableEditingProject()"
                      [ngStyle]="{ opacity: isEditDisable() ? '0.5' : '1' }"
                      [color]="isEditDisable() ? 'grey' : 'primary'"
                    >
                      редактировать
                    </app-button>
                  </a>
                } @else {
                  <app-button
                    appearance="outline"
                    color="red"
                    size="medium"
                    customTypographyClass="text-body-12"
                    (click)="this.isLeaveProjectModalOpen.set(true)"
                  >
                    выйти из проекта
                  </app-button>
                }
              }

              @defer (when isEditDisableModal()) {
                <app-modal [(open)]="isEditDisableModal">
                  <div
                    class="unsubscribe-modal"
                    style="text-align: center; padding: 20px; position: relative"
                  >
                    <i
                      style="right: 0px; top: 0px"
                      class="support__cross"
                      appIcon
                      icon="cross"
                      appSquare="12"
                      (click)="isEditDisableModal.set(false)"
                    ></i>
                    <img
                      src="assets/images/projects/shared/edit_disable.svg"
                      alt="idea"
                      sizes="120"
                      class="unsubscribe-modal__img"
                    />
                    <h4 class="support__title text-body-12">редактирование недоступно</h4>

                    <p class="support__text text-body-10">
                      Этот проект уже отправлен на конкурс. <br />Изменения будут доступны только
                      после окончания конкурса.
                    </p>

                    <app-button
                      appearance="outline"
                      size="medium"
                      customTypographyClass="text-body-12"
                      (click)="isEditDisableModal.set(false)"
                      >хорошо</app-button
                    >
                  </div>
                </app-modal>
              }

              @defer (when isLeaveProjectModalOpen()) {
                <app-modal [(open)]="isLeaveProjectModalOpen">
                  <div class="cancel" style="padding: 14px 24px">
                    <div class="cancel__top">
                      <h3 class="text-body-14 cancel__title" style="flex-wrap: wrap; width: 90%">
                        вы уверены, что хотите покинуть команду
                      </h3>
                      <i appIcon icon="sad-smile" appSquare="50" class="cancel__icon"></i>
                    </div>

                    <div class="cancel__buttons">
                      <app-button
                        color="red"
                        size="medium"
                        customTypographyClass="unsubscribe-modal-btn__typography"
                        (click)="onLeave()"
                      >
                        покинуть команду
                      </app-button>

                      <app-button
                        size="medium"
                        customTypographyClass="unsubscribe-modal-btn__typography"
                        (click)="onCloseLeaveProjectModal()"
                      >
                        остаться
                      </app-button>
                    </div>
                  </div>
                </app-modal>
              }
            } @else {
              <app-button
                [routerLink]="AppRoutes.projects.vacancies(info().id)"
                [appearance]="isVacanciesPage() ? 'inline' : 'outline'"
                size="medium"
                customTypographyClass="text-body-12"
              >
                вакансии
              </app-button>
            }
          </ng-template>

          <ng-template #profileTpl>
            @if (profile()) {
              @if (+profile()!.id === +info().id) {
                <app-button
                  size="medium"
                  appearance="outline"
                  customTypographyClass="text-body-12"
                  (click)="onCopyLink(info().id)"
                  >поделиться профилем</app-button
                >
              } @else {
                <app-button
                  size="medium"
                  appearance="outline"
                  customTypographyClass="text-body-12"
                  (click)="showApproveSkillModal.set(true)"
                  >подтвердить навыки</app-button
                >
              }
              @if (+profile()!.id === +info().id) {
                <app-button
                  style="opacity: 0.5"
                  size="medium"
                  appearance="outline"
                  [disabled]="true"
                  customTypographyClass="text-body-12"
                  >мои проекты</app-button
                >
              } @else {
                <app-button
                  size="medium"
                  appearance="outline"
                  customTypographyClass="text-body-12"
                  (click)="onCopyLink(info().id)"
                  >поделиться профилем</app-button
                >
              }

              <div class="info__divider"></div>

              @if (+profile()!.id === +info().id) {
                <app-button
                  (click)="downloadCV()"
                  size="medium"
                  [loader]="isSended()"
                  appearance="outline"
                  customTypographyClass="text-body-12"
                  >cкачать CV</app-button
                >
              } @else {
                <app-button
                  size="medium"
                  appearance="outline"
                  customTypographyClass="text-body-12"
                  (click)="inviteUser($event)"
                  >пригласить</app-button
                >
              }
              @if (+profile()!.id !== +info().id) {
                <a
                  class="info__send-message"
                  [routerLink]="AppRoutes.chats.detail(profile()!.id + '_' + info().id)"
                >
                  <app-button
                    appearance="outline"
                    size="medium"
                    [disabled]="true"
                    customTypographyClass="text-body-12"
                    >написать</app-button
                  >
                </a>
              } @else {
                <a
                  class="profile__edit"
                  [routerLink]="AppRoutes.profile.edit()"
                  [queryParams]="{ editingStep: 'main' }"
                >
                  <app-button
                    appearance="outline"
                    size="medium"
                    customTypographyClass="text-body-12"
                  >
                    редактировать
                  </app-button>
                </a>
              }

              @defer (when showApproveSkillModal()) {
                <app-modal
                  [open]="showApproveSkillModal()"
                  (openChange)="showApproveSkillModal.set(!showApproveSkillModal())"
                >
                  @if (info().skills.length) {
                    <ul class="approve">
                      <div class="lists__section">
                        <h3 class="text-body-12 lists__title">подтвердить владение навыком</h3>
                        <i
                          appIcon
                          icon="squiz"
                          class="lists__icon"
                          style="margin-top: 1px"
                          appSquare="12"
                        ></i>
                      </div>

                      @for (skill of info().skills; track skill.id) {
                        <li (click)="onOpenSkill(skill.id)">
                          <app-approve-skill [skill]="skill"></app-approve-skill>
                        </li>
                      }
                    </ul>
                  }
                </app-modal>
              }

              @if (showSendInviteModal()) {
                <app-profile-project-invite-modal
                  [projects]="profileProjects()"
                  [form]="inviteForm"
                  [selectedProjectId]="selectedProjectId()"
                  [loading]="detailProfileInfoService.inviteLoading()"
                  [error]="detailProfileInfoService.inviteError()"
                  [trigger]="inviteTrigger"
                  (selected)="selectedProjectId.set($event)"
                  (sent)="sendInvite()"
                  (closed)="detailProfileInfoService.closeInvite()"
                  (projectsRequested)="
                    detailProfileInfoService.closeInvite(); routingToMyProjects()
                  "
                />
              }
            }
            @if (profile()) {
              @if (profile()!.id === info().id) {
                @defer (when isProfileFill()) {
                  <app-modal
                    [open]="isProfileFill()"
                    (openChange)="!$event ? acknowledgeProfileFillPrompt() : null"
                  >
                    <div class="cancel">
                      <img
                        alt="profile unfill image"
                        class="cancel__image"
                        src="/assets/images/profile/profile-unfill.png"
                      />
                      <div class="cancel__top">
                        <i
                          (click)="acknowledgeProfileFillPrompt()"
                          appIcon
                          appSquare="12"
                          icon="cross"
                          class="cancel__cross"
                        ></i>
                        <p class="cancel__title text-body-14">
                          Заполните все поля, чтобы использовать PROCOLLAB на максимум
                        </p>
                      </div>
                      <p class="text-body-10 cancel__text">
                        Заполните все поля, чтобы иметь сильное резюме
                      </p>

                      <app-button
                        size="big"
                        customTypographyClass="text-body-12"
                        [disabled]="profileFillAcknowledgementPending()"
                        (click)="acknowledgeProfileFillPrompt(true)"
                      >
                        продолжить заполнение
                      </app-button>
                    </div>
                  </app-modal>
                }
              }
            }

            @defer (when isDelayModalOpen()) {
              <app-modal
                [open]="isDelayModalOpen()"
                (openChange)="isDelayModalOpen.set(!isDelayModalOpen())"
              >
                <div class="cancel">
                  <div class="cancel__top">
                    <i
                      (click)="isDelayModalOpen.set(false)"
                      appIcon
                      appSquare="8"
                      icon="cross"
                      class="cancel__cross"
                    ></i>
                    <p class="cancel__title text-bold-body-16">Повторите загрузку позже</p>
                  </div>
                  <p class="text-body-14 cancel__text">
                    Скачивание будет доступно через несколько секунд.
                  </p>
                </div>
              </app-modal>
            }
          </ng-template>

          <router-outlet></router-outlet>
        </div>
      </div>
    }
  </div>
</div>
